import { GlobalSettings, useGlobalSettings } from '../../../hooks/useGlobalSettings'

export type ShippingCountry = GlobalSettings['allSanityShippingCountry']['nodes'][number]

export const useShippingCountries = (): ShippingCountry[] =>
  useGlobalSettings().allSanityShippingCountry.nodes
